export default __webpack_public_path__ + "static/media/LandingPage.ddabfaf3.svg";